import {
  ITranslationMap,
  type ICustomMappingSourceOption,
} from '@principle-theorem/practice-migrations/interfaces';
import { type IManualTransactionType } from '@principle-theorem/principle-core/interfaces';
import {
  isSameRef,
  type AtLeast,
  type INamedDocument,
  type IXSLXExport,
  type XSLXCell,
} from '@principle-theorem/shared';
import type { Column } from 'exceljs';

export interface IPaymentMethodXSLX {
  sourceId: string;
  sourceName: string;
  mapTo: string;
}

export const PAYMENT_METHOD_HEADERS: AtLeast<Column, 'key' | 'header'>[] = [
  {
    key: 'sourceId',
    header: 'Payment Method',
  },
  {
    key: 'sourceName',
    header: 'Payment Method',
    width: 45,
  },
  {
    key: 'mapTo',
    header: 'Manual Transaction Type',
    width: 30,
  },
];

export class PaymentMethodToXSLX
  implements IXSLXExport<ICustomMappingSourceOption, IPaymentMethodXSLX>
{
  headers = PAYMENT_METHOD_HEADERS;

  constructor(
    private _manualTypes: INamedDocument<IManualTransactionType>[],
    private _existingMappings: ITranslationMap<IManualTransactionType>[]
  ) {}

  translate(
    records: ICustomMappingSourceOption[]
  ): Record<keyof IPaymentMethodXSLX, XSLXCell>[] {
    return records.map((record) => {
      const existingRecord = this._existingMappings.find(
        (existing) => existing.sourceIdentifier === record.value
      );

      const destinationIdentifier = existingRecord?.destinationIdentifier;
      const mappedType = destinationIdentifier
        ? this._manualTypes.find((type) =>
            isSameRef(type, destinationIdentifier)
          )
        : undefined;

      return {
        sourceId: {
          value: record.value,
        },
        sourceName: {
          value: record.label,
        },
        mapTo: {
          value: mappedType?.name,
          dataValidation: {
            type: 'list',
            formulae: [
              `"${this._manualTypes.map((type) => type.name).join(',')}"`,
            ],
          },
        },
      };
    });
  }
}
